var map = {
	"./basic_block/edit.vue": "./src/views/costPlatform/components/widgets/basic_block/edit.vue",
	"./basic_block/index.vue": "./src/views/costPlatform/components/widgets/basic_block/index.vue",
	"./basic_block/material.vue": "./src/views/costPlatform/components/widgets/basic_block/material.vue",
	"./basic_block/style.js": "./src/views/costPlatform/components/widgets/basic_block/style.js",
	"./basic_image/borderSvg.vue": "./src/views/costPlatform/components/widgets/basic_image/borderSvg.vue",
	"./basic_image/edit.vue": "./src/views/costPlatform/components/widgets/basic_image/edit.vue",
	"./basic_image/index.vue": "./src/views/costPlatform/components/widgets/basic_image/index.vue",
	"./basic_image/material.vue": "./src/views/costPlatform/components/widgets/basic_image/material.vue",
	"./basic_image/style.js": "./src/views/costPlatform/components/widgets/basic_image/style.js",
	"./basic_module/index.vue": "./src/views/costPlatform/components/widgets/basic_module/index.vue",
	"./basic_text/edit.vue": "./src/views/costPlatform/components/widgets/basic_text/edit.vue",
	"./basic_text/index.vue": "./src/views/costPlatform/components/widgets/basic_text/index.vue",
	"./basic_text/material.vue": "./src/views/costPlatform/components/widgets/basic_text/material.vue",
	"./basic_text/style.js": "./src/views/costPlatform/components/widgets/basic_text/style.js",
	"./layout_body/index.vue": "./src/views/costPlatform/components/widgets/layout_body/index.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views/costPlatform/components/widgets sync recursive \\.(vue|js)$";